(function () {
    "use strict";

    const ROOT_SELECTOR = "[data-quick-access-root]";
    const TEAM_REQUIRED_CHOICES = new Set(["rivalSendRivalRequest"]);
    let state = null;

    function bool(value) {
        return String(value || "").toLowerCase() === "true";
    }

    function nextFrame(callback) {
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(callback);
        });
    }

    function showFlowPanel(root, flow) {
        root.querySelectorAll(".target[data-group='quickMenuMain']").forEach(function (panel) {
            const selected = panel.id === flow;
            panel.classList.toggle("d-none", !selected);
            panel.classList.toggle("active", selected);
        });
    }

    function openTeamPrerequisite(root) {
        if (root.dataset.prerequisiteOpening === "team") return;
        root.dataset.prerequisiteOpening = "team";

        nextFrame(function () {
            if (typeof window.addTeam === "function") {
                window.addTeam();
                return;
            }

            root.dataset.prerequisiteOpening = "";
            root.querySelector(".addTeam")?.click();
        });
    }

    function openTournamentPrerequisite(root) {
        if (root.dataset.prerequisiteOpening === "tournament") return;
        root.dataset.prerequisiteOpening = "tournament";
        window.__quickAccessTournamentPrerequisiteAccepted = false;

        nextFrame(function () {
            if (typeof window.createModal === "function" && typeof window.Request === "function") {
                const modal = window.createModal({
                    title: "Turnuvanı Oluştur",
                    onClose: function () {
                        window.__quickAccessTournamentPrerequisiteModal = null;
                        root.dataset.prerequisiteOpening = "";

                        if (window.__quickAccessTournamentPrerequisiteAccepted) {
                            window.__quickAccessTournamentPrerequisiteAccepted = false;
                            return;
                        }

                        const quickAccessUrl = "/Hizli-Erisim";
                        if (typeof window.pageLink === "function") window.pageLink(quickAccessUrl);
                        else window.location.assign(quickAccessUrl);
                    }
                });
                window.__quickAccessTournamentPrerequisiteModal = modal;
                window.Request({
                    url: "/Member/_TournamentEmptyState",
                    type: "POST",
                    data: {}
                }).then(function (response) {
                    modal.updateContent(response);
                    root.dataset.prerequisiteOpening = "";
                }).catch(function (error) {
                    modal.updateContent('<div class="alert alert-danger m-2 text-center">' +
                        (error?.responseText || "Turnuva oluşturma ekranı yüklenemedi.") + '</div>');
                    root.dataset.prerequisiteOpening = "";
                });
                return;
            }

            root.dataset.prerequisiteOpening = "";
            root.querySelector(".AddTournament")?.click();
        });
    }

    function activateChoice(root, choice) {
        if (!choice || root.dataset.choiceActivated === choice) return;

        const selector = Array.from(root.querySelectorAll(".quick-access-choice[data-id]"))
            .find(function (item) { return item.dataset.id === choice; });
        if (!selector) return;

        root.dataset.choiceActivated = choice;
        nextFrame(function () {
            if (!root.isConnected) return;
            selector.click();
            selector.scrollIntoView({ block: "nearest", inline: "nearest" });
        });
    }

    function initializeFlow(root, flow) {
        if (bool(root.dataset.guest)) {
            showFlowPanel(root, flow);
            nextFrame(function () { if (root.isConnected) window.quickLoginModal?.(); });
            return;
        }
        document.body.classList.add("quick-access-flow-active");
        showFlowPanel(root, flow);

        const choice = root.dataset.choice || "";
        if (!choice) return;

        if (TEAM_REQUIRED_CHOICES.has(choice) && !bool(root.dataset.hasTeam)) {
            openTeamPrerequisite(root);
            return;
        }

        if (choice === "refereeTournament" && !bool(root.dataset.hasTournament)) {
            openTournamentPrerequisite(root);
            return;
        }

        activateChoice(root, choice);
    }

    function destroy() {
        if (state?.abortController) state.abortController.abort();
        state = null;
        document.body.classList.remove("quick-access-page-active", "quick-access-flow-active", "quick-access-detail-open");
    }

    window.destroyQuickAccessPage = destroy;

    document.addEventListener("click", function (event) {
        const button = event.target.closest(".continueTournamentCreation");
        if (!button) return;
        event.preventDefault();

        if (window.__quickAccessTournamentPrerequisiteModal &&
            typeof window.__quickAccessTournamentPrerequisiteModal.close === "function") {
            window.__quickAccessTournamentPrerequisiteAccepted = true;
            window.__quickAccessTournamentPrerequisiteModal.close();
            window.__quickAccessTournamentPrerequisiteModal = null;
        }

        if (state?.root?.dataset.choice === "refereeTournament") {
            window.__quickAccessTournamentResumeUrl = "/Hizli-Erisim/Hakem-Bul?choice=refereeTournament";
        }

        if (window.TournamentBuilder && typeof window.TournamentBuilder.open === "function") {
            window.TournamentBuilder.open(0);
            return;
        }
        document.querySelector(".AddTournament")?.click();
    });

    // Capture before delegated pageLink / match handlers can start an authenticated action.
    document.addEventListener("click", function (event) {
        const root = event.target.closest(ROOT_SELECTOR);
        if (!root || !bool(root.dataset.guest)) return;
        const action = event.target.closest(".quick-access-direct-action, .quick-access-choice, .quick-access-card, .addTeam, .CreateMatchPopUpBtn, .AddTournament");
        if (!action) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.quickLoginModal?.();
    }, true);

    window.initQuickAccessPage = function (rootElement) {
        const root = rootElement instanceof Element ? rootElement : document.querySelector(ROOT_SELECTOR);
        if (!root) {
            destroy();
            return null;
        }

        if (state?.root === root) return state;
        destroy();

        const abortController = new AbortController();
        const flow = root.dataset.flow || "";
        state = { root: root, flow: flow, abortController: abortController };

        if (flow) initializeFlow(root, flow);
        else document.body.classList.add("quick-access-page-active");

        root.addEventListener("keydown", function (event) {
            const mapCard = event.target.closest(".quick-access-map-card");
            if (!mapCard || (event.key !== "Enter" && event.key !== " ")) return;
            event.preventDefault();
            mapCard.click();
        }, { signal: abortController.signal });

        return state;
    };

    window.addEventListener("sahasenin:tournament-saved", function () {
        const resumeUrl = window.__quickAccessTournamentResumeUrl;
        if (!resumeUrl) return;

        window.__quickAccessTournamentResumeUrl = "";
        if (window.TournamentBuilder && typeof window.TournamentBuilder.close === "function") {
            window.TournamentBuilder.close(true);
        }

        if (typeof window.pageLink === "function") window.pageLink(resumeUrl);
        else window.location.assign(resumeUrl);
    });

    window.addEventListener("sahasenin:tournament-closed", function () {
        if (!window.__quickAccessTournamentResumeUrl) return;

        window.__quickAccessTournamentResumeUrl = "";
        const quickAccessUrl = "/Hizli-Erisim";
        if (typeof window.pageLink === "function") window.pageLink(quickAccessUrl);
        else window.location.assign(quickAccessUrl);
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { window.initQuickAccessPage(); }, { once: true });
    } else {
        window.initQuickAccessPage();
    }
})();
